import { useMemo } from 'react';

import { formatTimeWithTimeZone } from '@/lib/utils/format-time-with-timezone';
import { SubscriptionDetails } from '@addmile/backend-client';
import { CellContext } from '@tanstack/react-table';

export const useSubscriptionsTable = (subscriptions: SubscriptionDetails[]) => {
  const columns = useMemo(
    () => [
      {
        accessorKey: 'externalId',
        header: 'Subscription ID',
        cell: ({ getValue }: CellContext<SubscriptionDetails, string>) => <span>{getValue()}</span>,
        size: 300,
      },
      {
        accessorKey: 'provider',
        header: 'Provider',
        cell: ({ getValue }: CellContext<SubscriptionDetails, string>) => <span>{getValue()}</span>,
        size: 100,
      },
      {
        accessorKey: 'status',
        header: 'Status',
        cell: ({ getValue }: CellContext<SubscriptionDetails, string>) => <span>{getValue()}</span>,
        size: 100,
      },
      {
        accessorKey: 'expiresAt',
        header: 'Expires At',
        cell: ({ getValue }: CellContext<SubscriptionDetails, string>) =>
          typeof getValue() === 'string' ? formatTimeWithTimeZone(getValue()).dateOnly : getValue(),
        size: 80,
      },
      {
        accessorKey: 'kind',
        header: 'kind',
        cell: ({ getValue }: CellContext<SubscriptionDetails, string>) => <span>{getValue()}</span>,
        size: 80,
      },
      {
        id: 'actions',
        header: 'Actions',
        cell: ({ row }: CellContext<SubscriptionDetails, string>) => {
          if (row.original.provider !== 'solid') {
            return null;
          }
          return (
            <a
              href={`https://hub.solidgate.com/subscriptions/subscription/${row.original.externalId}`}
              className="button cursor-pointer transition duration-200 text-base font-semibold w-[112px] w-[122px] h-[36px] p-[9px_12px] gap-[6px] rounded-[8px_8px_8px_8px] bg-transparent text-black border border-primary-20 hover:border-primary-40"
              target="_blank"
              rel="noopener noreferrer"
            >
              View Details
            </a>
          );
        },
        size: 100,
      },
    ],
    [],
  );

  return { data: subscriptions, columns };
};
